module.exports = __webpack_public_path__ + "img/gjNum.e6857869.png";